<template>
  <div class="main"
       @click="toDetail(item.jobCode)">
    <div class="main_left">
      <div class="main_top">
        <p class="main_txt">{{item.title}}</p>
        <div class="main_icon"
             v-for="txt in item.tag.split(',').slice(0,2) "
             :key="txt">
          {{txt}}
        </div>
      </div>
      <p class="main_bot">{{item.companyName}}</p>
    </div>
    <div class="main_right">{{item.salary}}</div>
  </div>
</template>

<script>
export default {
  props: {
    item: {},
  },
  data () {
    return {

    }
  },
  created () {

  },
  methods: {
    toDetail (jobCode) {
      this.$router.push({
        path: "/details",
        query: { jobCode: jobCode },
      });
    }
  },
}
</script>

<style scoped>
.main {
  width: 540px;
  height: 88px;
  background: #f9f9f9;
  border-radius: 2px;
  margin-top: 10px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.main_left {
  display: flex;
  flex-direction: column;
}
.main_top {
  display: flex;
}
.main_txt {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
}
.main_icon {
  padding: 1px 2px;
  font-size: 14px;
  color: #e53631;
  background: #ffe6e5;
  border-radius: 2px;
  margin-left: 5px;
}
.main_bot {
  font-size: 16px;
  color: #999999;
  line-height: 16px;
  margin-top: 15px;
}
.main_right {
  font-size: 20px;
  font-weight: 600;
  color: #e53631;
  line-height: 20px;
}
</style>